import React, { FC } from 'react';
import styled from 'styled-components';

import { IProps, SLoader } from '@/presentation/loader/Loader.styled';

const SLoaderOverlay = styled.div`
  align-items: center;
  background: ${({ theme }) => theme.colors.primaryBackgroundA80};
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1;

  .k-justify-content-end & {
    justify-content: flex-end;

    ${SLoader} {
      margin: 0 8vw;
    }
  }
`;

const LoaderOverlay: FC<IProps> = ({ sizePx, borderPx, marginLeftPx }) => (
  <SLoaderOverlay>
    <SLoader sizePx={sizePx} borderPx={borderPx} marginLeftPx={marginLeftPx} />
  </SLoaderOverlay>
);

export default LoaderOverlay;
